import { Controller } from "@hotwired/stimulus"

// Toggle an inline "+ Add round" form on the season show page.
//
// The form lives in the DOM (initially hidden) so all of the round form's
// nested controllers (`event-track-filter`, `reminder-fields`,
// `training-day-fields`) wire up at boot. The trigger button reveals the
// form, hides itself, and focuses the round name input. Cancel reloads the
// page (existing form behavior).
export default class extends Controller {
  static targets = ["trigger", "form"]

  open(event) {
    event?.preventDefault()
    if (this.hasTriggerTarget) this.triggerTarget.classList.add("hidden")
    if (this.hasFormTarget) {
      this.formTarget.classList.remove("hidden")
      this.formTarget.scrollIntoView({ behavior: "smooth", block: "nearest" })
      const firstInput = this.formTarget.querySelector(
        "input[type='text'], input[type='datetime-local'], input[type='number'], select, textarea",
      )
      firstInput?.focus()
    }
  }
}
